import { min } from "moment";

const left = (stringValue: string | null, length: number | null = null) =>
{
    let res = null;

    if (stringValue) {
        if (length) {
            length = Math.min(stringValue.length, length);

            res = stringValue.substring(0, length);
        }
        else {
            res = stringValue;
        }
    }

    return(res);
}

const right = (stringValue: string | null, length: number | null = null) =>
{
    let res = null;

    if (stringValue) {
        if (length) {
            length = Math.min(stringValue.length, length);

            res = stringValue.substring(stringValue.length - length, stringValue.length);
        }
        else {
            res = stringValue;
        }
    }

    return(res);
}

const urlParamsStringToParamsObject = (stringValue: string | null) =>
{
    let res = { };

    if (stringValue) {
        const keyValueStringArray = stringValue.split('&');
        const keyValueArray = keyValueStringArray.map(x => x.split('='));

        res = keyValueArray.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), { });
    }

    return(res);
}

export
{
    left,
    right,
    urlParamsStringToParamsObject
}